import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Col, Form, Input, Layout, Row, Typography } from "antd";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { ShowToast, Severty } from "../../helper/toast";
import signinLogo from "../../assets/images/logo.svg";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function ResetPassword() {
  const { token } = useParams(); // Get token from URL path
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { request } = useRequest();

  const handleReset = async (values) => {
    setLoading(true);

    const { password, confirmPassword } = values;

    // Check if token exists
    if (!token) {
      ShowToast("Invalid or missing reset token", Severty.ERROR);
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      ShowToast("Passwords do not match.", Severty.ERROR);
      setLoading(false);
      return;
    }

    request({
      url: apiPath.resetPassword,
      method: "POST",
      data: {
        token: token, // Send the token from URL
        password: password,
        confirm_password: confirmPassword,
      },
      onSuccess: (data) => {
        ShowToast(
          data.message || "Password updated successfully",
          Severty.SUCCESS
        );
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      },
      onError: (error) => {
        console.error("Reset error", error);
        ShowToast(
          error.response?.data?.message || "Something went wrong",
          Severty.ERROR
        );
      },
    });

    setLoading(false);
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <div className="contant-bg-sign">
            <div className="signin-box">
              <div className="signup-logo">
                <img src={signinLogo} alt="Logo" />
              </div>
              <Row justify="space-around">
                <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                  <div className="signup-form">
                    <div className="login_header-mian">
                      <h4>Reset Your Password</h4>
                      <h5>Create a new password for your account</h5>
                    </div>

                    <Form
                      form={form}
                      onFinish={handleReset}
                      layout="vertical"
                      className="sign_in_formm"
                    >
                      <Form.Item
                        label="New Password"
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please enter your new password!",
                          },
                          {
                            pattern: new RegExp(
                              /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                            ),
                            message:
                              "Password must contain at least 8 characters, one capital letter, one small letter, one digit, and one special character",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Enter new password"
                          size="large"
                        />
                      </Form.Item>

                      <Form.Item
                        label="Confirm Password"
                        name="confirmPassword"
                        dependencies={["password"]}
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("Passwords do not match!")
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder="Confirm new password"
                          size="large"
                        />
                      </Form.Item>

                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="fill-button"
                          loading={loading}
                          style={{
                            width: "100%",
                            height: "40px",
                            marginBottom: "16px",
                          }}
                        >
                          {loading ? "Resetting..." : "Reset Password"}
                        </Button>
                      </Form.Item>
                    </Form>

                    <div style={{ textAlign: "center", marginTop: "20px" }}>
                      <Text style={{ fontSize: "14px", color: "#666" }}>
                        Remember your password?{" "}
                        <span
                          style={{
                            color: "#1890ff",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                          onClick={() => navigate("/login")}
                        >
                          Back to Login
                        </span>
                      </Text>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Content>
      </Layout>
    </div>
  );
}
